import { useNavigate } from "react-router-dom";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import Calculator from "../common/calculator";
import "./PersonalLoan.css";
import React, { useState, useEffect } from "react";
import Banklist from "../common/Banklist/Banklist";
import LoanForm from "../common/Form/Form";
import Services from "./ServicesPages/Services";
import TestimonialsSection from "../common/testimonials-section";

const PersonalLoan = () => {
  const navigate = useNavigate();

  return (
    <div className="personal-container">
      <section className="loan-hero-section">
        <div className="loan-hero-container">
          {/* LEFT CONTENT */}

          {/* RIGHT IMAGE */}

          <div className="loan-hero-image">
            <img src="/images/personal-loan.png" alt="personal loan" />
          </div>

          <div className="loan-hero-content">
            <h1>
              Get Your Personal Loan with Attractive <br />
              <span className="highlight">Interest Rates</span>
            </h1>

            <p>Apply for Personal Loan to fulfill all your financial needs</p>

            <input
              id="1"
              type="tel"
              placeholder="+91 9737304440"
              className="mobile-input"
              maxLength="10"
            />

            <div className="checkbox-row">
              <input type="checkbox" />
              <span>
                I agree to receive promotional message from WhatsApp/RCS/SMS.
              </span>
            </div>

            <button className="apply-btn">Apply Now →</button>
          </div>
        </div>

        {/* GREEN STATS CARD */}

        <div className="stats-card">
          <div className="stat">
            <p>Cities Covered</p>
            <h3>555+</h3>
          </div>

          <div className="stat">
            <p>Happy Customers</p>
            <h3>1 Lacs+</h3>
          </div>

          <div className="stat">
            <p>Banking Partners</p>
            <h3>158+</h3>
          </div>

          <div className="stat">
            <p>Disbursed Annually</p>
            <h3>₹53 BN</h3>
          </div>
        </div>
      </section>

      {/* DARK SECTION */}

      <section className="loan-info">
        <h2>
          Get Instant <span>Personal Loan</span>
        </h2>

        <p>
          A Personal Loan is one of the quickest and easiest ways to handle
          financial emergencies. It is an unsecured loan, which means you do not
          need to provide any collateral to apply. Whether you are a salaried
          professional, self-employed individual, or a retired person, you can
          easily apply for a personal loan based on your eligibility.
        </p>

        <p>
          Krishna Finconcept Services offers a reliable and fast solution for
          all your short-term and long-term financial needs with collateral-free
          personal loans. With competitive interest rates starting from just 11%
          per annum, minimal documentation, and flexible repayment tenures
          ranging from 12 to 60 months, our personal loan solutions make
          managing your finances simple and convenient.
        </p>
      </section>
      <section className="loan-usage-section">
        <div className="loan-container">
          <div className="loan-left">
            <h2>
              Smart Ways to Use Your <span>Personal Loan</span>
            </h2>

            <p>
              Personal loans help you manage sudden financial needs without the
              stress of arranging collateral. With quick approval and minimal
              paperwork, you can easily handle important expenses.
            </p>

            <p>
              <strong>Krishana Finconcept Services</strong> offers fast and
              reliable loan solutions with flexible repayment options and
              competitive interest rates.
            </p>
          </div>

          <div className="loan-right">
            <div className="loan-card">
              <h4>Medical Emergencies</h4>
              <p>
                Cover hospital bills and unexpected medical expenses easily.
              </p>
            </div>

            <div className="loan-card">
              <h4>Home Renovation</h4>
              <p>Upgrade or repair your home with easy financing options.</p>
            </div>

            <div className="loan-card">
              <h4>Wedding Expenses</h4>
              <p>Plan your dream wedding without financial stress.</p>
            </div>

            <div className="loan-card">
              <h4>Travel & Vacation</h4>
              <p>Enjoy holidays and travel plans without using your savings.</p>
            </div>
          </div>
        </div>
      </section>
      <section className=" modern-variant unique-hero-design">
        {/* 3. Right Side: The Hero Text */}
        <div className="homeloan-hero-text animated-entrance">
          <div className="badge-glow animated-item">Instant Cash Solutions</div>

          <h1 className="title animated-item">
            Achieve Your Financial Goals With Our <span>Personal Loan!</span>
          </h1>

          <div className="features-flex animated-item">
            <div className="feat-pill">
              <span className="icon">✔</span> Flexible Repayment
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Competitive Rates
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Minimal Paperwork
            </div>
          </div>

          <div className="content-body animated-item">
            <p className="subtitle">
              Fulfill your financial needs with our reliable Personal Loan
              services. <strong>Krishana Finconcept</strong> has partnered with
              leading banks to provide fast and hassle-free solutions.
            </p>

            <p className="subtitle">
              Whether it's for medical emergencies, travel, home renovation, or
              education, we ensure a smooth approval process with affordable
              EMIs designed to suit your situation.
            </p>
          </div>

          {/* 4. Action Button */}
          <div className="cta-wrapper animated-item">
            <button
              className="high-conversion-btn"
              onClick={() => {
                navigate("/services/2", { state: { scrollToApply: true } });
              }}
            >
              <span className="btn-text">Apply For Personal loan</span>
              <div className="btn-glow-shimmer"></div>
            </button>
          </div>
        </div>
      </section>

      <TestimonialsSection />

      <Services
        slug="2"
        title="Personal Loan EMI Calculator – Calculate Your Monthly EMI Online"
      />
    </div>
  );
};

export default PersonalLoan;
